import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2380773144/src/src/app/@travelCardModal/(...)travelCard/[id]/page.tsx");
